import React from 'react';
import styled from 'styled-components';

import MainLogo from '@components/navigation/MainLogo';
import { useRecoilValue } from 'recoil';
import MusicButton from '@template/MusicPlayer/MusicBtn';
import NavList from '../common/NavList';
import {
  layoutDirState,
  menuTypeState,
  menuWidthState,
} from '@atom/setting/homepageSet';
import { MENU_DESIGN_TYPE } from '@typings/menu/menuType';
import NotificationBtn from '@template/Notifications/NotificationBtn';
import { masterSet } from '@masterSetting/masterSet/masterSetting';
import DdayWidget from '@template/Widget/DdayWidget';
import { SettingCollectionPath } from '@typings/collections.enum';
import { useDocument } from '@nandorojo/swr-firestore';
import { IhomepageSetting } from '@typings/setting/homepageSetting.interface';
import LoginUserSec from '../common/LoginUserSec';
import ChatBtn from '@pages/Chat/ChatBtn';
import { LAYOUT_DIR } from '@typings/setting/layoutDir';
import { scrollbarHide } from '@styles/variants/scrollbar';

const NavWrapper = styled.nav`
  width: 220px;
  position: fixed;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  background: top/contain no-repeat;
  z-index: 2;

  // 이게 있으면, 메뉴의 tooltip이 뜨지 않음.
  // 없으면, 메뉴가 길어질 때 스크롤이 안됌
  overflow-y: auto;
  ${scrollbarHide}
`;

const BtnWrap = styled.div`
  display: flex;
  padding: 0 12px;
  margin-top: 12px;
`;

function LeftNav() {
  const menuType = useRecoilValue(menuTypeState);
  const layoutDir = useRecoilValue(layoutDirState);
  const menuWidth = useRecoilValue(menuWidthState);

  const { data: homeSet, set } = useDocument<IhomepageSetting>(
    `${SettingCollectionPath.HOMEPAGE}`,
    { listen: true },
  );

  return (
    <NavWrapper
      style={{
        width: menuWidth || 220,
        backgroundImage:
          menuType === MENU_DESIGN_TYPE.NONE ||
            menuType === MENU_DESIGN_TYPE.COLOR
            ? ''
            : 'var(--menuImgURL)',
        backgroundColor:
          menuType === MENU_DESIGN_TYPE.COLOR
            ? 'var(--menuBackgroundColor)'
            : '',
        paddingBottom: '24px'
      }}
    >
      <MainLogo style={{ marginBottom: 16 }} />

      <NavList />

      {homeSet?.ddayWidget?.showDdayWidget && masterSet.widget?.ddayWidget && (
        <DdayWidget />
      )}
      <BtnWrap>
        <MusicButton color="var(--menuTextColor)" />
        <NotificationBtn
          dropdownDir={
            layoutDir === LAYOUT_DIR.LEFT ? 'bottomLeft' : 'bottomRight'
          }
          color="var(--menuTextColor)"
        />
        {masterSet.chat && <ChatBtn color="var(--menuTextColor)" />}
      </BtnWrap>

      <LoginUserSec
        dropdownDir={
          layoutDir === LAYOUT_DIR.LEFT ? 'bottomLeft' : 'bottomRight'
        }
        showDisplayName
        style={{ width: '100%', padding: '20px' }}
      />
    </NavWrapper>
  );
}

export default LeftNav;
